import React from 'react';
import L from 'leaflet';

export const WaypointMarker = new L.DivIcon({
  html: `<svg width="20" height="20" viewBox="0 0 20 20" fill="white" xmlns="http://www.w3.org/2000/svg">
  <circle cx="10" cy="10" r="7.5" stroke="white" stroke-width="5"/>
</svg>`,
  iconAnchor: [10, 10],
  iconSize: [16, 16],
  className: 'waypoint-confirm'
});

export const WaypointMarkerArrow = (rotationAngle: number) => new L.DivIcon({
  html: `<svg width="20" height="20" viewBox="0 0 20 20" fill="white" xmlns="http://www.w3.org/2000/svg">
  <circle cx="10" cy="10" r="7.5" stroke="white" stroke-width="5"/>
  <polyline points="5,4 16,10 5,16" stroke="black" transform="rotate(${rotationAngle}, 10, 10)" stroke-width="2"/>
</svg>`,
  iconAnchor: [10, 10],
  iconSize: [16, 16],
  className: 'waypoint-confirm'
});

export const AutoAddedWaypointMarker = new L.DivIcon({
  html: `<svg width="12" height="12" viewBox="0 0 20 20" fill="white" xmlns="http://www.w3.org/2000/svg">
  <circle cx="10" cy="10" r="7.5" stroke="white" stroke-width="5"/>
</svg>`,
  iconAnchor: [10, 10],
  iconSize: [10, 10],
  className: 'waypoint-confirm'
});

export const DroneMarker = new L.DivIcon({
  html: `<svg width="20" height="20" viewBox="0 0 20 20" fill="white" xmlns="http://www.w3.org/2000/svg">
    <circle cx="10" cy="10" r="7.5" stroke="green" stroke-width="5"/>
  </svg>`,
  iconAnchor: [10, 10],
  iconSize: [16, 16],
  className: 'waypoint-confirm'
});

export const EndPointMarker = new L.DivIcon({
  html: `<svg width="20" height="20" viewBox="0 0 20 20" fill="white" xmlns="http://www.w3.org/2000/svg">
    <circle cx="10" cy="10" r="7.5" stroke="red" stroke-width="5"/>
  </svg>`,
  iconAnchor: [10, 10],
  iconSize: [16, 16],
  className: 'waypoint-confirm'
});

export const SuggestedPointMarker = new L.DivIcon({
  html: `<svg width="20" height="20" viewBox="0 0 20 20" fill="white" xmlns="http://www.w3.org/2000/svg">
    <circle cx="10" cy="10" r="7.5" stroke="green" stroke-width="5"/>
  </svg>`,
  iconAnchor: [10, 10],
  iconSize: [16, 16],
  className: 'waypoint-confirm'
});

export const SelectedPointMarker = new L.DivIcon({
  html: `<svg width="20" height="20" viewBox="0 0 20 20" fill="white" xmlns="http://www.w3.org/2000/svg">
    <circle cx="10" cy="10" r="7.5" stroke="gray" stroke-width="5"/>
  </svg>`,
  iconAnchor: [10, 10],
  iconSize: [16, 16],
  className: 'waypoint-confirm'
});

export const RouteStartMarker = new L.DivIcon({
  html: `<svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M36.6667 18.3334C36.6667 25.5768 26.3461 34.8371 21.9478 38.4546C20.8064 39.3934 19.1937 39.3934 18.0523 38.4546C13.6539 34.8371 3.33337 25.5768 3.33337 18.3334C3.33337 9.12867 10.7953 1.66675 20 1.66675C29.2048 1.66675 36.6667 9.12867 36.6667 18.3334Z" fill="#0583FF" stroke="white" stroke-width="3.33333"/>
  <circle cx="20" cy="18.3333" r="5" stroke="white" stroke-width="3.33333"/>
  </svg>`,
  iconAnchor: [24, 24],
  iconSize: [48, 48],
  className: 'waypoint-confirm'
});

export const CurrentDropPointIcon = new L.DivIcon({
  html: `<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="23" cy="21" r="16" stroke="white" stroke-opacity="0.6" stroke-width="2"/>
      <g filter="url(#filter0_d_2981_40109)">
        <circle cx="23" cy="21" r="11" fill="#0583FF"/>
        <circle cx="23" cy="21" r="10" stroke="white" stroke-width="2"/>
      </g>
    <circle cx="23" cy="21" r="2" fill="white"/>
    <defs>
      <filter id="filter0_d_2981_40109" x="0" y="0" width="48" height="48" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset dy="4"/>
        <feGaussianBlur stdDeviation="12"/>
        <feComposite in2="hardAlpha" operator="out"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2981_40109"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2981_40109" result="shape"/>
      </filter>
    </defs>
  </svg>`,
  iconAnchor: [24, 24],
  iconSize: [48, 48],
  className: 'waypoint-confirm'
});

export const CurrentDropPointIconRed = new L.DivIcon({
  html: `<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="23" cy="21" r="16" stroke="white" stroke-opacity="0.6" stroke-width="2"/>
      <g filter="url(#filter0_d_2981_40109)">
        <circle cx="23" cy="21" r="11" fill="#FF0000"/>
        <circle cx="23" cy="21" r="10" stroke="white" stroke-width="2"/>
      </g>
    <circle cx="23" cy="21" r="2" fill="white"/>
    <defs>
      <filter id="filter0_d_2981_40109" x="0" y="0" width="48" height="48" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset dy="4"/>
        <feGaussianBlur stdDeviation="12"/>
        <feComposite in2="hardAlpha" operator="out"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2981_40109"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2981_40109" result="shape"/>
      </filter>
    </defs>
  </svg>`,
  iconAnchor: [24, 24],
  iconSize: [48, 48],
  className: 'waypoint-confirm'
});

export const AmberDropPointIcon = new L.DivIcon({
  html: `<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="23" cy="21" r="16" stroke="white" stroke-opacity="0.6" stroke-width="2"/>
      <g filter="url(#filter0_d_2981_40109)">
        <circle cx="23" cy="21" r="11" fill="#d97706"/>
        <circle cx="23" cy="21" r="10" stroke="white" stroke-width="2"/>
      </g>
    <circle cx="23" cy="21" r="2" fill="white"/>
    <defs>
      <filter id="filter0_d_2981_40109" x="0" y="0" width="48" height="48" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset dy="4"/>
        <feGaussianBlur stdDeviation="12"/>
        <feComposite in2="hardAlpha" operator="out"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2981_40109"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2981_40109" result="shape"/>
      </filter>
    </defs>
  </svg>`,
  iconAnchor: [24, 24],
  iconSize: [48, 48],
  className: 'waypoint-confirm'
});

export const PreviousDropPointIcon = new L.DivIcon({
  html: `<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_2981_40097)">
      <circle cx="23" cy="21" r="11" fill="black" fill-opacity="0.38" shape-rendering="crispEdges"/>
      <circle cx="23" cy="21" r="10" stroke="white" stroke-width="2" shape-rendering="crispEdges"/>
    </g>
    <circle cx="23" cy="21" r="2" fill="white"/>
    <defs>
      <filter id="filter0_d_2981_40097" x="0" y="0" width="48" height="48" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset dy="4"/>
        <feGaussianBlur stdDeviation="12"/>
        <feComposite in2="hardAlpha" operator="out"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2981_40097"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2981_40097" result="shape"/>
      </filter>
    </defs>
  </svg>`,
  iconAnchor: [24, 24],
  iconSize: [48, 48],
  className: 'waypoint-confirm'
});

export const getCurrentDropPointIcon = (sizeInPixels = 48) => new L.DivIcon({
  html: `<svg width="${sizeInPixels}" height="${sizeInPixels}" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_2981_40109)">
      <circle cx="23" cy="21" r="23" fill="#0583FF"/>
      <circle cx="23" cy="21" r="22" stroke="white" stroke-width="2"/>
    </g>
    <circle cx="23" cy="21" r="2" fill="white"/>
    <defs>
      <filter id="filter0_d_2981_40109" x="0" y="0" width="${sizeInPixels}" height="${sizeInPixels}" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset dy="4"/>
        <feGaussianBlur stdDeviation="12"/>
        <feComposite in2="hardAlpha" operator="out"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2981_40109"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2981_40109" result="shape"/>
      </filter>
    </defs>
  </svg>`,
  iconAnchor: [(sizeInPixels / 2), (sizeInPixels / 2)],
  iconSize: [sizeInPixels, sizeInPixels],
  className: 'waypoint-confirm'
});

export const getPreviousDropPointIcon = (sizeInPixels = 48) => new L.DivIcon({
  html: `<svg width="${sizeInPixels}" height="${sizeInPixels}" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_2981_40097)">
      <circle cx="23" cy="21" r="23" fill="black" fill-opacity="0.38" shape-rendering="crispEdges"/>
      <circle cx="23" cy="21" r="22" stroke="white" stroke-width="2" shape-rendering="crispEdges"/>
    </g>
    <circle cx="23" cy="21" r="2" fill="white"/>
    <defs>
      <filter id="filter0_d_2981_40097" x="0" y="0" width="${sizeInPixels}" height="${sizeInPixels}" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset dy="4"/>
        <feGaussianBlur stdDeviation="12"/>
        <feComposite in2="hardAlpha" operator="out"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2981_40097"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2981_40097" result="shape"/>
      </filter>
    </defs>
  </svg>`,
  iconAnchor: [(sizeInPixels / 2), (sizeInPixels / 2)],
  iconSize: [sizeInPixels, sizeInPixels],
  className: 'waypoint-confirm'
});
